/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetProgramChannelProviderRequest
 */
export interface GetProgramChannelProviderRequest {
    /**
     * 
     * @type {string}
     * @memberof GetProgramChannelProviderRequest
     */
    programChannelProviderId: string;
}

export function GetProgramChannelProviderRequestFromJSON(json: any): GetProgramChannelProviderRequest {
    return GetProgramChannelProviderRequestFromJSONTyped(json, false);
}

export function GetProgramChannelProviderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProgramChannelProviderRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'programChannelProviderId': json['program_channel_provider_id'],
    };
}

export function GetProgramChannelProviderRequestToJSON(value?: GetProgramChannelProviderRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'program_channel_provider_id': value.programChannelProviderId,
    };
}


